module.exports = __webpack_public_path__ + "img/ball_0_transparent.1e680a2d.png";